import { combineReducers } from "redux";
import ejercicioReducer from "./ejercicio";
import anatomiaReducer from "./anatomia";
import cargandoReducer from "./cargando";
import loginReducer from "./login";
import navegaReducer from "./nevegacion";
import exploracionReducer from "./exploracion";
import situarReducer from "./situar";
import videoReducer from "./popupvideo";

const reducers = combineReducers({
	ejercicio: ejercicioReducer,
	video: videoReducer,
	anatomia: anatomiaReducer,
	cargando: cargandoReducer,
	login: loginReducer,
	exploracion: exploracionReducer,
	navegacion: navegaReducer,
	situar:situarReducer,
});

export default reducers;
